<template>
    <div class="container section-menu-page">
        <div class="section-title-wrap">
            <h2 class="section-title">{{ labels.title }}</h2> 
        </div>
        <div>
            <div class="" style="background-color: white; border-radius: 28px; box-shadow: 0px 3px 5px #dcd7cc;">
                <b-container style="padding: 40px;">
                    <b-row id="home-buttons" v-for="subMenu in listaSubMenu" :key="subMenu.id"> 
                        <b-col md="4" class="p-2" col="3" @click="goToRoute(subMenu.ruta)"> 
                            <div md-with-hover class="md-card">
                                <div>
                                    <div>
                                        <div class="md-title-tarjeta">
                                          <span>{{ subMenu?.nombre }}</span> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                        <b-col md="8" class="p-2" col="3">
                            <div md-with-hover class="div-description">
                                <div>
                                    <div>
                                        <div class="md-title-description">
                                          <span>{{ subMenu?.descripcion }}</span> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </b-container>
            </div>
        </div>
    </div>
</template>
<script>
import SubMenu from '../../services/SubMenu'; 
    export default {
        name:"Parametrizacion",

        data: () => ({
            listaSubMenu : []
        }),

        computed:{
            labels(){
                if (this.$store.state._language == "es-ES") { 
                    return {
                        title: "Consulta cierres",
                    }
                }else{
                    return {
                        title: "Check closures",
                    }
                }
            }
        },
        methods:{
            goToRoute(page){
                this.$router.push({path: page }) 
            }
        },
        mounted(){
            SubMenu.subMenuByMenuByRol(this.$route.name,this.$store.state.userRole) 
            .then((res) => { 
                // console.log(res.data.submenus) 
                // console.log(this.$store) 
                this.listaSubMenu = res.data.submenus 
            })
            .catch((err) => { console.log(err)}) 
        }
    }

</script>
